<template>
  <div class="card">
    <div style="height: unset" class="card-image" v-if="$slots.image">
      <slot name="image"></slot>
    </div>
    <div class="card-header text-center" :class="headerClass ? headerClass : ''" v-if="$slots.header || title">
      <slot name="header">
        <h4 class="card-title">{{title}}  <label  v-if="total" class="badge badge-danger text-white ml-3">{{total}} </label> </h4>
        <p class="card-category" v-if="subTitle">{{subTitle}}</p>
      </slot>
    </div>
    <div class="card-body" :class="bodyClass ? bodyClass : ''" v-if="$slots.default">
      <slot></slot>
    </div>
    <slot name="raw-content"></slot>
    <div class="card-footer" v-if="$slots.footer">
      <hr>
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "card",
  props: {
    title: String,
    subTitle: String,
    headerClass: {
      type: String,
      default: null,
      required: false
    },
     bodyClass: {
      type: String,
      default: null,
      required: false
    },
    total: {
      type: Number,
      required : false
    },
  }
};
</script>
<style>
</style>
